export { default as AdBanner } from './components/AdBanner';
export { default as AdInterstitial } from './components/AdInterstitial';
export { adBlockDetector } from './services/adBlockDetector';
export { h5GamesAds, showInterstitialAd, showRewardedAd, initializeAds } from './services/h5GamesAds';

// 광고 슬롯 ID (AdSense에서 생성 후 교체 필요) - 레거시 호환용
export const AD_SLOTS = {
  // 배너 광고
  LOBBY_BANNER: '1234567890',
  MATCHING_BANNER: '1234567891',
  
  // 전면 광고
  DEBATE_END: '1234567892',
  
  // 보상형 광고
  REWARD_EXTRA_GAME: '1234567893',
} as const;
